export function GetGuid(): number {
	return Math.floor(Math.random() * 999999);
}

export function FormatBytes(bytes: number, decimals = 2) {
	if (!+bytes) return "0 Bytes";

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export function hasMutipleSpaces(string: string): boolean {
	return /\s{2,}/.test(string);
}

export function FireWindowClick() {
	(document as any).getElementById("app").click();
}
